<template>
  <v-layout>
    <div class="padding-container-lg">
      <v-page-header>
        <template
          v-if="carePlan"
          slot="subHead"
        >
          Care ID - {{ carePlan.plan_no }}
        </template>
      </v-page-header>
      <div
        v-if="carePlan"
        class="row pb-4"
      >
        <b-form-group
          label="Title"
          label-for="CareplanTitle"
          class="col col-md-6 col-12"
        >
          <div class="border-text">{{ carePlan.title }}</div>
        </b-form-group>
        <b-form-group
          label="Category"
          label-for="category"
          class="col col-md-6 col-12"
        >
          <div
            v-if="carePlan.category && carePlan.category.name"
            class="border-text"
          >{{ carePlan.category.name }}</div>
        </b-form-group>
        <b-form-group
          label="Goal"
          label-for="goal"
          class="col col-md-6 col-12"
        >
          <div class="border-text">{{ carePlan.goal }}</div>
        </b-form-group>
        <b-form-group
          label="Problem"
          label-for="problem"
          class="col col-md-6 col-12"
        >
          <div class="border-text">{{ carePlan.problem }}</div>
        </b-form-group>
        <b-form-group
          label="Duration"
          label-for="planDuration"
          class="col col-md-6 col-lg-3 col-sm-6 col-12"
        >
          <div class="border-text">{{ carePlan.plan_duration }} days</div>
        </b-form-group>
        <b-form-group
          label="Cycles"
          label-for="cycles"
          class="col col-md-6 col-lg-3 col-sm-6 col-12"
        >
          <div class="border-text">{{ carePlan.cycles === 1500 ? 'Perpetual' : `${carePlan.cycles} times`}}</div>
        </b-form-group>
        <b-form-group
          label="Break b/w cycles"
          label-for="breakCycles"
          class="col col-md-6 col-lg-3 col-sm-6 col-12"
        >
          <div class="border-text">{{ carePlan.break_time }} days</div>
        </b-form-group>
        <b-form-group
          label="Start date"
          label-for="planStartDate"
          class="col col-md-6 col-lg-3 col-sm-6 col-12"
        >
          <div class="border-text">
            {{ defaultDateFormat(carePlan.plan_start_date) }}
          </div>
        </b-form-group>
        <b-form-group
          label="End date"
          label-for="planEndDate"
          class="col col-md-6 col-lg-3 col-sm-6 col-12"
        >
          <div class="border-text">
            {{ defaultDateFormat(carePlan.plan_end_date) }}
          </div>
        </b-form-group>
        <div class="row no-gutters col-12">
          <b-form-checkbox v-model="carePlan.is_enrollment" name="Enroll careplan" :disabled="true">is Enrollment Careplan</b-form-checkbox>
        </div>
      </div>
      <template v-if="carePlan">
        <v-accordion
          v-if="careplanIntervention"
          :data="careplanIntervention"
          :module="modules.intervene"
        />
        <v-accordion
          v-if="careplanAssessment"
          :data="careplanAssessment"
          :module="modules.assessment"
        />
        <v-accordion
          v-if="careplanInstruction"
          :data="careplanInstruction"
          :module="modules.instruction"
        />
      </template>
      <template v-if="hasSlot('action')">
        <slot name="action" />
      </template>
    </div>
    <v-loader :isLoading="isCareplanLoading" />
  </v-layout>
</template>

<script>
import VLayout from '@/layouts/Default.vue';
import VPageHeader from '@/components/pageheader/PageHeader.vue';
import VAccordion from '@/components/careplan/Accordion.vue';
import modules from '@/views/CarePlan/_modules';
import SlotMixin from '@/mixins/slot';
import VLoader from '@/components/loader/index.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ViewCareplan',
  components: {
    VLayout, VPageHeader, VAccordion, VLoader
  },
  mixins: [
    SlotMixin
  ],
  props: {
    carePlan: { type: Object, required: true },
    careplanIntervention: { type: Object, required: true },
    careplanAssessment: { type: Object, required: true },
    careplanInstruction: { type: Object, required: true }
  },
  data() {
    return {
      modules
    };
  },
  computed: {
    ...mapGetters({
      isCareplanLoading: 'careplan/getIsCareplanLoading'
    })
  }
};
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
